// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4a2a5300","88":"b7b7f477","126":"ea95e0d2","277":"dafd7e87","577":"45740fb9","614":"8d3b9d76","624":"caebfb9d","703":"1b12d6d3","739":"ab95eafb","789":"c61f5dc1","953":"3d2533f0","957":"a6f64683","987":"e883f664"}[chunkId] + ".chunk.js";
};